// Rails routes the register links out to. Kept together so a routing change is a
// single edit rather than a hunt through the component tree.
export const editCategoryPath = (tradeId) => `/categories/${tradeId}/edit`;

export const newRiskAssessmentPath = (tradeId) =>
  `/categories/${tradeId}/risk_assessments/new`;

export const riskAssessmentPath = (tradeId, masterActivityId) =>
  `/categories/${tradeId}/risk_assessments/${masterActivityId}`;
